import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';

/**
 * "Show / hide the extension slides" toggle of the beamer nav — one cell of the layout's grid (`display: contents`).
 * Pure UI: the layout handles `toggled`.
 * Styles: libs/styles/slide-sync/beamer-navigation/_nav-parts.scss (global, beamer themes).
 */
@Component({
    selector: 'pcp-nav-extension-toggle',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconButton, MatIcon, MatTooltip, TranslocoPipe],
    template: `
        <div class="grid-cell">
            @if (!shown() || !hasSlides()) {
                <button
                    mat-icon-button
                    (click)="toggled.emit(true)"
                    [disabled]="!hasSlides()"
                    class="additional-content"
                    matTooltip="Erweiterungselemente anzeigen"
                    [class.not-visible]="!hasSlides()"
                    [title]="'icon-button.additional-content' | transloco"
                >
                    <mat-icon>collections</mat-icon>
                </button>
            } @else {
                <button
                    mat-icon-button
                    (click)="toggled.emit(false)"
                    class="additional-content"
                    matTooltip="Erweiterungselemente ausblenden"
                    [title]="'icon-button.additional-content' | transloco"
                >
                    <mat-icon>close</mat-icon>
                </button>
            }
        </div>
    `,
})
export class NavExtensionToggleComponent {
    /** The extension slides preview is open. */
    readonly shown = input(false);
    /** The current slide has extension slides. */
    readonly hasSlides = input(false);
    /** true = show the extension slides, false = hide them. */
    readonly toggled = output<boolean>();
}
